<script>

    import { toast } from 'bulma-toast'
    import { createEventDispatcher } from 'svelte'
    import { chargesStore, modalStore } from '../stores'

    import ChargesService from '../$services/charges.service'
    import DateMethod from '../$methods/date.method'

    import Spinner from '../$components/spinner.svelte'
    import DetailsCard from '../$components/details.card.svelte'
    import DetailsFields from '../$components/details.fields.svelte'
    import DetailsField from '../$components/details.field.svelte'
    import ButtonDelete from '../$components/button.delete.svelte'

    const dispatch = createEventDispatcher()

    export let charge = null

    let loading = false

    async function deleteCharge() {

        loading = true
        const resp = await ChargesService.deleteCharge(charge._id)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        chargesStore.remove(charge._id)

        toast({message: 'Cargo borrado', type: 'is-success'})
        dispatch('delete')
        modalStore.close()
    }

</script>

<Spinner {loading} />

{#if !loading && charge}
    <DetailsCard
        title="Cargo"
        meta={DateMethod.dateTimeLarge(charge.created)}
        statusValue={charge.status}
    >
        <DetailsFields>
            {#if charge.admin && charge.admin.name}
                <DetailsField label="Admin" value={charge.admin.name} />
            {/if}
            <DetailsField label="Tipo" value={charge.type} />
            <DetailsField label="Método" value={charge.method} />
            <DetailsField label="Concepto" value={charge.concept} />
            <DetailsField label="Monto" value={`$${charge.amount}`} mono />
            <DetailsField label="Detalles" value={charge.details || ''} />
            {#if charge.shipment && charge.shipment.created}
                <DetailsField label="Guía" value={charge.shipment.guide} />
                <DetailsField label="Fecha envío" value={DateMethod.dateTimeLarge(charge.shipment.created)} />
            {/if}
        </DetailsFields>

        <div slot="footer">
            <div class="is-flex is-justify-content-flex-end is-align-items-center">
                <ButtonDelete on:confirm={deleteCharge} {loading} />
            </div>
        </div>
    </DetailsCard>
{/if}
